<i18n>
{
  "en": {
    "title": "You're already registered!",
    "description-1": "We already sent an email for",
    "description-2": "with your password and login url, remember to check your trash or spam box."
  },
  "pt-BR": {
    "title": "Você já está cadastrado!",
    "description-1": "Nós já enviamos um email para",
    "description-2": "contendo suas credenciais e página de acesso, verifique também na lixeira ou na caixa de spam!"
  }
}
</i18n>

<template>
  <div class="step already-registered">
    <h2>{{ $t("title") }}</h2>
    <p>
      {{ $t("description-1") }} <b>{{ lead.email }}</b>
      {{ $t("description-2") }}
    </p>
    <img
      class="undraw"
      src="@/assets/undraw/email-opened.svg"
      width="138"
      height="124"
      :alt="$t('title')"
    />
  </div>
</template>

<script>
export default {
  computed: {
    lead() {
      return this.$store.getters.getLead;
    }
  }
};
</script>

<style></style>
